import React, { useState } from 'react';

import ModalToBody from '../../../base/ModalToBody';
import { Certificate } from '../../../hooks/api/utils/types';
import ReviewCertificateForm from './ReviewCertificateForm';

type Props = {
  certificate: Certificate;
  onReview?: () => void;
};

export default function ReviewCertificateButton({ certificate, onReview }: Props) {
  const [showModal, setShowModal] = useState(false);

  const onSuccess = () => {
    onReview?.();
    closeModal();
  }

  const closeModal = () => {
    setShowModal(false);
  };

  const openModal = () => {
    setShowModal(true);
  };

  if (showModal) {
    document.body.classList.add('modal-open');
  } else {
    document.body.classList.remove('modal-open');
  }

  return (
    <>
      <button
        type="button"
        onClick={openModal}
        className="btn btn-outline-primary m-btn btn-sm  m-btn--icon m--margin-left-5"
      >
        <span>
          <i className="la la-eye" />
          <span>Review</span>
        </span>
      </button>

      <ModalToBody>
        <div
          className="modal fade show"
          id="m_modal_4"
          role="dialog"
          aria-labelledby="exampleModalLabel"
          style={{
            display: showModal ? 'block' : 'none',
            zIndex: 1039,
          }}
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  Review certificate
                </h5>
                <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={closeModal}>
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              {showModal && (
                <ReviewCertificateForm certificate={certificate} onSuccess={onSuccess} onCancel={closeModal} />
              )}
            </div>
          </div>
        </div>

        <div
          className={'modal-backdrop fade ' + (showModal ? ' show' : '')}
          style={{
            display: showModal ? 'block' : 'none',
            zIndex: 1038,
          }}
        />
      </ModalToBody>
    </>
  );
}
